import { jsx } from "panel";
import { QueryBlockEl } from "common/query-builder/query-block";
export function template() {
  const { addingBlock, prefixRenderer, stagingSelected } = this.state;
  const selected = stagingSelected || this.attr(`selected`);
  const MultiBlockItem = ({ selection, idx }) => {
    const serializedSelection = JSON.stringify(selection);
    return /* @__PURE__ */ jsx(null, null, prefixRenderer ? /* @__PURE__ */ jsx("div", {
      sel: ".mp-query-multi-block-prefix"
    }, prefixRenderer(idx, selection)) : null, /* @__PURE__ */ jsx("div", {
      sel: ".mp-query-multi-block-item",
      key: serializedSelection
    }, /* @__PURE__ */ jsx(QueryBlockEl, {
      attrs: this.helpers.getQueryBlockAttrs({
        elref: `queryBlock`,
        "prefix-label": this.attr(idx === 0 ? `first-block-prefix` : `block-prefix`),
        removable: true,
        selected: serializedSelection
      }),
      on: {
        remove: () => this.helpers.removeSelection(selection),
        select: (ev) => this.helpers.modifySelection(idx, ev),
        track: this.helpers.preventTracking
      }
    })));
  };
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-query-multi-block",
    class: { [`${this.attr(`layout`)}-layout`]: true }
  }, selected.map((selection, idx) => /* @__PURE__ */ jsx(MultiBlockItem, {
    selection,
    idx
  })), !this.attr(`adding-disabled`) && this.helpers.canAddMore() ? /* @__PURE__ */ jsx(null, null, prefixRenderer ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-query-multi-block-prefix"
  }, prefixRenderer(selected.length, null)) : null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-query-multi-block-item",
    key: "new-block-item"
  }, /* @__PURE__ */ jsx(QueryBlockEl, {
    attrs: this.helpers.getQueryBlockAttrs({
      "selector-icon": this.attr(`button-icon`),
      "selector-type": this.attr(`button-selector-type`),
      theme: this.attr(`button-selector-theme`),
      label: this.helpers.buttonText(),
      "input-only": true,
      tooltip: this.attr(`tooltip`),
      open: this.attr(`button-open`) || addingBlock,
      elref: `addBlock`
    }),
    dataset: {
      key: `new-block`
    },
    on: {
      select: this.helpers.commitNewBlock,
      track: this.helpers.preventTracking,
      open: () => this.helpers.setAddingBlock(true),
      close: this.helpers.onAddItemBlockClose
    }
  }))) : null);
}
